import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ThingsToDoPage = lazy(() => import('../pages/things-to-do/page'));
const DayTripsPage = lazy(() => import('../pages/day-trips/page'));
const BestTimePage = lazy(() => import('../pages/best-time-to-visit/page'));
const WeatherPage = lazy(() => import('../pages/weather/page'));
const BestHotelsPage = lazy(() => import('../pages/best-hotels/page'));
const AntiguaGuidePage = lazy(() => import('../pages/antigua-guide/page'));
const AntiguaSafePage = lazy(() => import('../pages/antigua-safe/page'));
const AirportTransferPage = lazy(() => import('../pages/airport-transfer/page'));
const AcatenangoHikePage = lazy(() => import('../pages/acatenango-hike/page'));
const BudgetGuidePage = lazy(() => import('../pages/budget-guide/page'));
const ItinerariesPage = lazy(() => import('../pages/itineraries/page'));
const ThreeDayItineraryPage = lazy(() => import('../pages/antigua-itinerary-3-days/page'));
const TwoWeekItineraryPage = lazy(() => import('../pages/2-week-itinerary/page'));
const PlanTripPage = lazy(() => import('../pages/plan-trip/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const EditorialPolicyPage = lazy(() => import('../pages/editorial-policy/page'));
const PacayaVolcanoPage = lazy(() => import('../pages/pacaya-volcano/page'));
const AntiguaToChichicastenangoPage = lazy(() => import('../pages/antigua-to-chichicastenango/page'));
const HobbitenangoPag = lazy(() => import('../pages/hobbitenango/page'));
const AntiguaToLakeAtitlanPage = lazy(() => import('../pages/antigua-to-lake-atitlan/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/things-to-do-in-antigua-guatemala',
    element: <ThingsToDoPage />
  },
  {
    path: '/day-trips-from-antigua-guatemala',
    element: <DayTripsPage />
  },
  {
    path: '/best-time-to-visit-antigua-guatemala',
    element: <BestTimePage />
  },
  {
    path: '/antigua-guatemala-weather',
    element: <WeatherPage />
  },
  {
    path: '/best-hotels-in-antigua-guatemala',
    element: <BestHotelsPage />
  },
  {
    path: '/antigua-guatemala-travel-guide',
    element: <AntiguaGuidePage />
  },
  {
    path: '/is-antigua-guatemala-safe',
    element: <AntiguaSafePage />
  },
  {
    path: '/guatemala-city-airport-to-antigua',
    element: <AirportTransferPage />
  },
  {
    path: '/acatenango-hike-from-antigua',
    element: <AcatenangoHikePage />
  },
  {
    path: '/antigua-guatemala-budget-guide',
    element: <BudgetGuidePage />
  },
  {
    path: '/antigua-guatemala-itineraries',
    element: <ItinerariesPage />
  },
  {
    path: '/itineraries',
    element: <ItinerariesPage />
  },
  {
    path: '/antigua-guatemala-3-day-itinerary',
    element: <ThreeDayItineraryPage />
  },
  {
    path: '/antigua-guatemala-2-week-itinerary',
    element: <TwoWeekItineraryPage />
  },
  {
    path: '/plan-my-antigua-trip',
    element: <PlanTripPage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '/terms-of-service',
    element: <TermsPage />
  },
  {
    path: '/editorial-policy',
    element: <EditorialPolicyPage />
  },
  {
    path: '/pacaya-volcano-day-trip-from-antigua',
    element: <PacayaVolcanoPage />
  },
  {
    path: '/antigua-to-chichicastenango',
    element: <AntiguaToChichicastenangoPage />
  },
  {
    path: '/hobbitenango-antigua-guatemala',
    element: <HobbitenangoPag />
  },
  {
    path: '/antigua-to-lake-atitlan-shuttle',
    element: <AntiguaToLakeAtitlanPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;